import React from 'react'
import { FaFacebookSquare } from 'react-icons/fa'
import Button from '../button'
import Facebook from '../../images/icons/newFacebookIcon.png'
import styled from 'styled-components'

const FacebookIcon = styled.img`
  width: 32px;
  height: 32px;
  cursor: pointer;
  @media (max-width: 820px) {
    height: 40px;
    width: 40px;
  }
  @media (max-width: 768px) {
    height: 40px;
    width: 40px;
  }
  @media (max-width: 426px) {
    height: 36px;
    width: 36px;
  }
`

const FacebookButton = ({ children, callback, isIcon, margin = '' }) => {
  const handleResponse = (data) => {
    callback(data?.accessToken)
  }
  const handleError = (error) => {
    console.log(error)
  }
  const handleClick = () => {
    window.FB.login(
      function (response) {
        if (response.status === 'connected') {
          handleResponse(response.authResponse)
        } else {
          handleError()
        }
        console.log({ response })
      },
      { scope: 'public_profile,email' }
    )
  }

  return (
    <>
      {isIcon ? (
        <div style={{ margin: margin }}>
          <FacebookIcon src={Facebook} alt="facebook-btn" onClick={handleClick} />
        </div>
      ) : (
        <Button
          id="login.button.with.facebook"
          margin="20px 0px 0px"
          facebook
          full
          icon={<FaFacebookSquare style={{ fill: 'white' }} />}
          onClick={handleClick}
        >
          {children}
        </Button>
      )}
    </>
  )
}

export default FacebookButton
